import { render, staticRenderFns } from "./SearchAddressView.vue?vue&type=template&id=227bec0e&scoped=true"
import script from "./SearchAddressView.vue?vue&type=script&lang=js"
export * from "./SearchAddressView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bec0e",
  null
  
)

export default component.exports